import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

console.log('🌐 API_URL:', API_URL);

const $host = axios.create({
    baseURL: API_URL
});

const $authHost = axios.create({
    baseURL: API_URL
});

const authInterceptor = config => {
    const token = localStorage.getItem('token');
    console.log('🔑 Токен для запроса:', token);
    if (token) {
        config.headers.authorization = `Bearer ${token}`;
    }
    return config;
};

$authHost.interceptors.request.use(authInterceptor);

export {
    $host,
    $authHost
};